export const data=
 [ 
    
   {
    name: '2018', value:2000000000,
    name: '2019', value:1500000000,
    name: '2020', value:100000000,
    name: '2021', value:5000000000,
    category: 'Barchart',
    id: '1'
   },
   {
    name: '2018', value:2000000000,
    name: '2019', value:1500000000,
    name: '2020', value:100000000,
    name: '2021', value:5000000000,
    category: 'Piechart',
    id: '2'
   },
   {
    name: '2018', value:2000000000,
    name: '2019', value:1500000000,
    name: '2020', value:100000000,
    name: '2021', value:5000000000,
    category: 'Areachart',
    id: '3'
   },
   {
    name: '2018', value:2000000000,
    name: '2019', value:1500000000,
    name: '2020', value:100000000,
    name: '2021', value:5000000000,
    category: 'Tinylinechart',
    id: ''
   },
   {
    name: '2018', value:2000000000,
    name: '2019', value:1500000000,
    name: '2020', value:100000000,
    name: '2021', value:5000000000,
    category: 'Linechart',
    id: ''
   },
 ]